import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';

class SignInContainer extends Component {
  render() {
    const { show, initialState, onHide, onSignIn } = this.props;

    return (
      <React.Fragment>
        <Button variant="primary" onClick={onSignIn}>
           Sign In
        </Button>
        <Modal show={show} onHide={onHide}>
          <ThemeProvider>
            <Authenticator
              loginMechanisms={["email"]}
              signUpAttributes={["given_name", "family_name"]}
              initialState={initialState}>
              {({ signOut, user }) => (
                <main>
                  <h1>Hello {user.username}</h1>
                    <Button onClick={signOut}>Sign out</Button>
                  </main>
                )
              }
            </Authenticator>
          </ThemeProvider>
        </Modal>
      </React.Fragment>
    );
  }
}

export default SignInContainer
